import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
//css
import "./Single.scss";
//Components
import Navbar from "../../../shared/components/navbar/Navbar";
import Sidebar from "../../../shared/components/sidebar/Sidebar";

import PdfOrcamentoSeguradoWrapper from "../../../shared/components/PdfGenerator/PdfOrcamento/PdfOrcamentoSegurado/PdfOrcamentoSeguradoWrapper";
import PdfOrcamentoParticularWrapper from "../../../shared/components/PdfGenerator/PdfOrcamento/PdfOrcamentoParticular/PdfOrcamentoParticularWrapper";
import PdfPrescricaoWrapper from "../../../shared/components/PdfGenerator/PdfPrescricao/PdfPrescricaoWrapper";
import PdfAtestadoWrapper from "../../../shared/components/PdfGenerator/PdfAtestado/PdfAtestadoWrapper";
import FluxoAtendimento from "./components/FluxoAtendimento/FluxoAtendimento";
import PdfFaturaWrapper from "../../../shared/components/PdfGenerator/PdfFatura/PdfFaturaWrapper";
import PdfImpressoWrapper from "../../../shared/components/PdfGenerator/PdfImpresso/PdfImpressoWrapper";
import PdfOrcamentoMistoWrapper from "../../../shared/components/PdfGenerator/PdfOrcamento/PdfOrcamentoMisto/PdfOrcamentoMistoWrapper";
import PdfRequisicaoExamesWrapper from "../../../shared/components/PdfGenerator/PdfRequisicaoExames/PdfRequisicaoExamesWrapper";

//Custom Hooks
import { useHttpClient } from "../../../shared/hooks/http-hook";

//MUI Icons
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
//Context
import { AuthContext } from "../../../shared/context/auth-context";
import { ClinicaContext } from "../../../shared/context/clinica-context";
import Debitos from "./components/Debitos/Debitos";
import InfoGeral from "./components/InfoGeral/InfoGeral";
import Documentos from "./components/Documentos/Documentos";
import Ficheiros from "./components/Ficheiros/Ficheiros";
import Historico from "./components/Historico/Historico";
import PdfReciboWrapper from "../../../shared/components/PdfGenerator/PdfRecibo/PdfReciboWrapper";
import { useLoading } from "../../../shared/context/LoadingContext";

import Odontograma from "./components/Odontograma/Odontograma";
import PdfProximosAgendamentosWrapper from "../../../shared/components/PdfGenerator/PdfProximosAgendamentos/PdfProximosAgendamentosWrapper";
import PdfConsentimentosWrapper from "../../../shared/components/PdfGenerator/PdfConsentimentos/PdfConsentimentosWrapper";
import PdfTcleWrapper from "../../../shared/components/PdfGenerator/PdfConsentimentos/PdfTcleWrapper";
import PdfRceWrapper from "../../../shared/components/PdfGenerator/PdfRce/PdfRceWrapper";
import PdfExtratoClienteWrapper from "../../../shared/components/PdfGenerator/PdfExtratoCliente/PdfExtratoClienteWrapper";

function Single() {
  const { startLoading, stopLoading } = useLoading();

  const [userData, setUserData] = useState();
  const [balancoGeralCliente, setBalancoGeralCliente] = useState();
  const [orcamentoData, setOrcamentoData] = useState({ show: false });
  const [prescricaoData, setPrescricaoData] = useState({ show: false });
  const [reciboData, setReciboData] = useState({ show: false });
  const [atestadoData, setAtestadoData] = useState({ show: false });
  const [impressoData, setImpressoData] = useState({ show: false });
  const [faturaData, setFaturaData] = useState({ show: false });
  const [dadosRce, setDadosRce] = useState({ show: false });
  const [extratoData, setExtratoData] = useState({ show: false });
  const [requisicaoData, setRequisicaoData] = useState({ show: false });
  const [consentimentoData, setConsentimentoData] = useState({ show: false });
  const [tcleData, setTcleData] = useState({ show: false });
  const [proximosAgendamentosData, setProximosAgendamentosData] = useState({
    show: false,
  });
  const [showMainTabs, setShowMainTabs] = useState("");

  const { sendRequest } = useHttpClient();
  const auth = useContext(AuthContext);
  const clinica = useContext(ClinicaContext);

  const temporary = useParams().clienteId;
  const clienteId = temporary.split("-")[0];

  useEffect(() => {
    //Caso na barra de enderecos conter plano de tratamento, orcamento ou avaliacao,
    //A aba de fluxo de Atendimento irá ficar aberta
    //Dentro de useEffect para evitar renders infinitos
    const aba = temporary.split("-")[1];
    if (
      aba === "avaliacao" ||
      aba === "planotratamento" ||
      aba === "orcamento" ||
      aba === "tratamentoIsolado"
    )
      setShowMainTabs("fluxoAtendimento");
    else if (
      aba === "impresso" ||
      aba === "prescricao" ||
      aba === "atestado" ||
      aba === "requisicaoexames" ||
      aba === "consentimento"
    )
      setShowMainTabs("documentos");
    else if (aba === "debitos") setShowMainTabs("debitos");
    else if (aba === "documentos") setShowMainTabs("documentos");
    else if (aba === "ficheiros") setShowMainTabs("ficheiros");
    else if (aba === "historico") setShowMainTabs("historico");
    else if (aba === "debitos") setShowMainTabs("debitos");
    else if (aba === "odontograma") setShowMainTabs("odontograma");
    else setShowMainTabs("infoGeral");
  }, [temporary]);

  useEffect(() => {
    const fetchCliente = async () => {
      startLoading();
      try {
        const [responseCliente, balanco] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/comanamnese/${clienteId}?clinicaId=${clinica.clinica._id}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/contascorrentes/cliente/balancofinanceiro/${clienteId}`,
            "GET",
            null,
            {
              Authorization: "Bearer " + auth.token,
            },
          ),
        ]);
        setBalancoGeralCliente(balanco);
        setUserData(responseCliente.cliente);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchCliente();
  }, [sendRequest, clienteId, clinica, auth]);

  const changeClienteNotasData = (notas) => {
    setUserData((prev) => ({ ...prev, notasDebitos: notas }));
  };

  const dadosRequisicao = (dados) => {
    setRequisicaoData({ ...dados, show: true });
  };

  const dadosConsentimento = (dados) => {
    setConsentimentoData({ ...dados, show: true });
  };

  const dadosTcle = (dados) => {
    setTcleData({ ...dados, show: true });
  };

  const dadosOrcamento = (dados) => {
    setOrcamentoData({ ...dados, show: true });
  };

  const dadosPrescricao = (dados) => {
    setPrescricaoData({ ...dados, show: true });
  };

  const dadosAtestado = (dados) => {
    setAtestadoData({ ...dados, show: true });
  };

  const dadosImpresso = (dados) => {
    setImpressoData({ ...dados, show: true });
  };

  const dadosFatura = (dados) => {
    setFaturaData({ ...dados, show: true });
  };

  const dadosRecibo = (dados) => {
    setReciboData({ ...dados, show: true });
  };

  const showRce = (dadosRce) => {
    setDadosRce(dadosRce);
  };

  /* O extrato e o mesmo PDF que o relatorio de extrato usa. Chega aqui, e nao
     ao Debitos, porque os PDFs substituem a pagina inteira — e e o `Single`
     que sabe como voltar atras (`showSinglePage`). */
  const showExtrato = (dados) => {
    setExtratoData({ dados, show: true });
  };

  const dadosProximosAgendamentos = (dados) => {
    setProximosAgendamentosData({
      lista: dados,
      clinica: clinica.clinica,
      cliente: userData,
      show: true,
    });
  };

  const showSinglePage = () => {
    if (dadosRce.show) {
      setDadosRce({ show: false });
    }

    if (extratoData.show) {
      setExtratoData({ show: false });
    }

    if (orcamentoData.show)
      setOrcamentoData((current) => {
        return { ...current, show: false };
      });

    if (prescricaoData.show)
      setPrescricaoData((current) => {
        return { ...current, show: false };
      });

    if (impressoData.show)
      setImpressoData((current) => {
        return { ...current, show: false };
      });

    if (atestadoData.show)
      setAtestadoData((current) => {
        return { ...current, show: false };
      });

    if (faturaData.show)
      setFaturaData((current) => {
        return { ...current, show: false };
      });

    if (reciboData.show)
      setReciboData((current) => {
        return { ...current, show: false };
      });

    if (requisicaoData.show)
      setRequisicaoData((current) => {
        return { ...current, show: false };
      });

    if (consentimentoData.show)
      setConsentimentoData((current) => {
        return { ...current, show: false };
      });

    if (tcleData.show)
      setTcleData((current) => {
        return { ...current, show: false };
      });

    if (proximosAgendamentosData.show)
      setProximosAgendamentosData((current) => {
        return { ...current, show: false };
      });
  };

  /////////
  return (
    <>
      {orcamentoData.show && orcamentoData.tipo === "SEGURADO" && (
        <PdfOrcamentoSeguradoWrapper
          showSinglePage={showSinglePage}
          orcamentoData={orcamentoData}
        />
      )}
      {orcamentoData.show && orcamentoData.tipo === "Misto" && (
        <PdfOrcamentoMistoWrapper
          showSinglePage={showSinglePage}
          orcamentoData={orcamentoData}
        />
      )}
      {reciboData.show && (
        <PdfReciboWrapper
          showPreviousPage={showSinglePage}
          reciboData={reciboData}
        />
      )}
      {orcamentoData.show && orcamentoData.tipo === "Particular" && (
        <PdfOrcamentoParticularWrapper
          showSinglePage={showSinglePage}
          orcamentoData={orcamentoData}
        />
      )}
      {prescricaoData.show && (
        <PdfPrescricaoWrapper
          showPreviousPage={showSinglePage}
          prescricaoData={prescricaoData}
        />
      )}
      {atestadoData.show && (
        <PdfAtestadoWrapper
          showPreviousPage={showSinglePage}
          atestadoData={atestadoData}
        />
      )}
      {impressoData.show && (
        <PdfImpressoWrapper
          showPreviousPage={showSinglePage}
          impressoData={impressoData}
        />
      )}
      {faturaData.show && (
        <PdfFaturaWrapper
          showPreviousPage={showSinglePage}
          faturaData={faturaData}
        />
      )}

      {requisicaoData.show && (
        <PdfRequisicaoExamesWrapper
          showPreviousPage={showSinglePage}
          requisicaoData={requisicaoData}
        />
      )}

      {consentimentoData.show && (
        <PdfConsentimentosWrapper
          showPreviousPage={showSinglePage}
          consentimentoData={consentimentoData}
        />
      )}

      {tcleData.show && (
        <PdfTcleWrapper showPreviousPage={showSinglePage} tcleData={tcleData} />
      )}

      {proximosAgendamentosData.show && (
        <PdfProximosAgendamentosWrapper
          showPreviousPage={showSinglePage}
          proximosAgendamentosData={proximosAgendamentosData}
        />
      )}

      {dadosRce.show && (
        <PdfRceWrapper
          showPreviousPage={showSinglePage}
          reciboData={dadosRce}
        />
      )}

      {extratoData.show && (
        <PdfExtratoClienteWrapper
          showPreviousPage={showSinglePage}
          dados={extratoData.dados}
        />
      )}

      {userData && (
        <div className="single">
          <Sidebar />
          <div className="singleContainer">
            <Navbar
              title={userData.nome}
              icon={PersonOutlineOutlinedIcon}
              iconBtn={BorderColorOutlinedIcon}
            />

            <div className="single__abas-principais single__abas-principais--cliente">
              <span
                className={`single__abas-principais__aba ${
                  showMainTabs === "infoGeral" &&
                  "single__abas-principais__aba--active"
                }`}
                onClick={() => setShowMainTabs("infoGeral")}
              >
                Info Geral
              </span>
              {(auth.perm.includes("r-aval") ||
                auth.perm.includes("r-orc") ||
                auth.perm.includes("r-plt")) && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "fluxoAtendimento" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("fluxoAtendimento")}
                >
                  Fluxo Atendimento
                </span>
              )}

              {auth.perm.includes("r-deb") && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "debitos" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("debitos")}
                >
                  Débitos
                </span>
              )}

              {auth.perm.includes("r-hist") && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "historico" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("historico")}
                >
                  Histórico
                </span>
              )}

              {/* {auth.perm.includes("r-odont") && ( */}
              <span
                className={`single__abas-principais__aba ${
                  showMainTabs === "odontograma" &&
                  "single__abas-principais__aba--active"
                }`}
                onClick={() => setShowMainTabs("odontograma")}
              >
                Odontograma
              </span>
              {/* )} */}

              {(auth.perm.includes("r-pres") ||
                auth.perm.includes("r-ates")) && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "documentos" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("documentos")}
                >
                  Documentos
                </span>
              )}
              {auth.perm.includes("r-anex") && (
                <span
                  className={`single__abas-principais__aba ${
                    showMainTabs === "ficheiros" &&
                    "single__abas-principais__aba--active"
                  }`}
                  onClick={() => setShowMainTabs("ficheiros")}
                >
                  Ficheiros
                </span>
              )}
            </div>

            <div className="singleContainer__all">
              {showMainTabs === "infoGeral" && auth.perm.includes("r-cli") && (
                <InfoGeral
                  clienteId={clienteId}
                  clinicaId={clinica.clinica._id}
                  sendRequest={sendRequest}
                  userData={userData}
                  balancoGeralCliente={balancoGeralCliente}
                  dadosProximosAgendamentos={dadosProximosAgendamentos}
                />
              )}
              {showMainTabs === "fluxoAtendimento" &&
                (auth.perm.includes("r-aval") ||
                  auth.perm.includes("r-orc") ||
                  auth.perm.includes("r-plt")) && (
                  <FluxoAtendimento
                    dadosOrcamento={dadosOrcamento}
                    clienteId={clienteId}
                    sendRequest={sendRequest}
                    token={auth.token}
                  />
                )}

              {showMainTabs === "documentos" &&
                (auth.perm.includes("r-ates") ||
                  auth.perm.includes("r-pres") ||
                  auth.perm.includes("r-impr")) && (
                  <Documentos
                    dadosPrescricao={dadosPrescricao}
                    dadosAtestado={dadosAtestado}
                    dadosImpresso={dadosImpresso}
                    dadosRequisicao={dadosRequisicao}
                    dadosConsentimento={dadosConsentimento}
                    dadosTcle={dadosTcle}
                    clienteId={clienteId}
                    sendRequest={sendRequest}
                  />
                )}

              {showMainTabs === "historico" && auth.perm.includes("r-hist") && (
                <Historico
                  clienteId={clienteId}
                  sendRequest={sendRequest}
                  clienteData={userData}
                />
              )}

              {showMainTabs === "odontograma" &&
                auth.perm.includes("r-plt") && (
                  <Odontograma
                    clienteId={clienteId}
                    sendRequest={sendRequest}
                    auth={auth}
                  />
                )}

              {showMainTabs === "debitos" && auth.perm.includes("r-deb") && (
                <Debitos
                  clienteId={clienteId}
                  sendRequest={sendRequest}
                  nomeCliente={userData.nome}
                  dadosFatura={dadosFatura}
                  clienteData={userData}
                  dadosRecibo={dadosRecibo}
                  changeClienteNotasData={changeClienteNotasData}
                  showRce={showRce}
                  showExtrato={showExtrato}
                />
              )}

              {showMainTabs === "ficheiros" && auth.perm.includes("r-anex") && (
                <Ficheiros clienteId={clienteId} />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Single;
